export const MIN_API_LEVEL = 8;

export const PAGE_SIZE = 25;
